import React from 'react';

import AppShell from '../components/AppShell';
import { logout } from '../services/sessionService';
import { useProvider } from './ProviderContext';
import './provider.css';

const initialsOf = (name) => {
  const parts = String(name || '').trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return '';
  const first = parts[0].charAt(0);
  const last = parts.length > 1 ? parts[parts.length - 1].charAt(0) : '';
  return `${first}${last}`.toUpperCase();
};

const NAV = [
  { to: '/provider/home', label: 'Início', icon: 'home' },
  { to: '/provider/evaluated', label: 'Avaliações', icon: 'star' },
  { to: '/provider/my-config', label: 'Atendimento', icon: 'wrench' },
  { to: '/provider/my-data', label: 'Minha oficina', icon: 'store' },
];

// Moldura da area da oficina: a mesma do cliente (AppShell), com as abas da oficina.
export default function ProviderShell({ children }) {
  const { company } = useProvider();
  const name = company ? company.tradingName || company.name : '';

  const handleLogout = async () => {
    await logout('provider');
    window.location.href = '/provider/login';
  };

  return (
    <AppShell
      nav={NAV}
      homePath='/provider/home'
      homeLabel='Sobre Rodas, área da oficina'
      profile={{ to: '/provider/my-data', initials: initialsOf(name) || '·', label: 'Minha oficina' }}
      onLogout={handleLogout}
    >
      {children}
    </AppShell>
  );
}
